import ImageUploadForm from "./components/ImageUploadForm";

const Upload = () => {
  return <ImageUploadForm />;
};

export default Upload;
